// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/worksheets.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { DatasetResponse } from "../../common/v1/dataset_response_pb";
import { file_chalk_common_v1_dataset_response } from "../../common/v1/dataset_response_pb";
import type { OfflineQueryRequest } from "../../common/v1/offline_query_pb";
import { file_chalk_common_v1_offline_query } from "../../common/v1/offline_query_pb";
import type { OnlineQueryRequest, OnlineQueryResponse } from "../../common/v1/online_query_pb";
import { file_chalk_common_v1_online_query } from "../../common/v1/online_query_pb";
import type { ExecuteSqlQueryRequest, ExecuteSqlQueryResponse } from "../../protosql/v1/sql_service_pb";
import { file_chalk_protosql_v1_sql_service } from "../../protosql/v1/sql_service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/worksheets.proto.
 */
export const file_chalk_server_v1_worksheets: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_chalk_auth_v1_permissions, file_chalk_common_v1_dataset_response, file_chalk_common_v1_offline_query, file_chalk_common_v1_online_query, file_chalk_protosql_v1_sql_service, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.WorksheetSpace
 */
export type WorksheetSpace = Message<"chalk.server.v1.WorksheetSpace"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetSpaceVisibility visibility = 3;
   */
  visibility: WorksheetSpaceVisibility;

  /**
   * @generated from field: optional string owner_user_id = 4;
   */
  ownerUserId?: string;
};

/**
 * Describes the message chalk.server.v1.WorksheetSpace.
 * Use `create(WorksheetSpaceSchema)` to create a new message.
 */
export const WorksheetSpaceSchema: GenMessage<WorksheetSpace> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 0);

/**
 * @generated from message chalk.server.v1.WorksheetBlobRef
 */
export type WorksheetBlobRef = Message<"chalk.server.v1.WorksheetBlobRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string content_schema = 3;
   */
  contentSchema: string;

  /**
   * @generated from field: string content_hash = 4;
   */
  contentHash: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.WorksheetBlobRef.
 * Use `create(WorksheetBlobRefSchema)` to create a new message.
 */
export const WorksheetBlobRefSchema: GenMessage<WorksheetBlobRef> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 1);

/**
 * @generated from message chalk.server.v1.WorksheetContent
 */
export type WorksheetContent = Message<"chalk.server.v1.WorksheetContent"> & {
  /**
   * @generated from field: string content_schema = 1;
   */
  contentSchema: string;

  /**
   * @generated from field: bytes content_proto_bytes = 2;
   */
  contentProtoBytes: Uint8Array;

  /**
   * @generated from field: optional string content_hash = 3;
   */
  contentHash?: string;
};

/**
 * Describes the message chalk.server.v1.WorksheetContent.
 * Use `create(WorksheetContentSchema)` to create a new message.
 */
export const WorksheetContentSchema: GenMessage<WorksheetContent> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 2);

/**
 * @generated from message chalk.server.v1.WorksheetSqlQueryDocument
 */
export type WorksheetSqlQueryDocument = Message<"chalk.server.v1.WorksheetSqlQueryDocument"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryRequest request = 1;
   */
  request?: ExecuteSqlQueryRequest;
};

/**
 * Describes the message chalk.server.v1.WorksheetSqlQueryDocument.
 * Use `create(WorksheetSqlQueryDocumentSchema)` to create a new message.
 */
export const WorksheetSqlQueryDocumentSchema: GenMessage<WorksheetSqlQueryDocument> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 3);

/**
 * @generated from message chalk.server.v1.WorksheetOnlineQueryDocument
 */
export type WorksheetOnlineQueryDocument = Message<"chalk.server.v1.WorksheetOnlineQueryDocument"> & {
  /**
   * @generated from field: chalk.common.v1.OnlineQueryRequest request = 1;
   */
  request?: OnlineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.WorksheetOnlineQueryDocument.
 * Use `create(WorksheetOnlineQueryDocumentSchema)` to create a new message.
 */
export const WorksheetOnlineQueryDocumentSchema: GenMessage<WorksheetOnlineQueryDocument> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 4);

/**
 * @generated from message chalk.server.v1.WorksheetOfflineQueryDocument
 */
export type WorksheetOfflineQueryDocument = Message<"chalk.server.v1.WorksheetOfflineQueryDocument"> & {
  /**
   * @generated from field: chalk.common.v1.OfflineQueryRequest request = 1;
   */
  request?: OfflineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.WorksheetOfflineQueryDocument.
 * Use `create(WorksheetOfflineQueryDocumentSchema)` to create a new message.
 */
export const WorksheetOfflineQueryDocumentSchema: GenMessage<WorksheetOfflineQueryDocument> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 5);

/**
 * @generated from message chalk.server.v1.WorksheetNotebookDocument
 */
export type WorksheetNotebookDocument = Message<"chalk.server.v1.WorksheetNotebookDocument"> & {
  /**
   * @generated from field: bytes notebook_proto_bytes = 1;
   */
  notebookProtoBytes: Uint8Array;

  /**
   * @generated from field: optional string notebook_schema = 2;
   */
  notebookSchema?: string;
};

/**
 * Describes the message chalk.server.v1.WorksheetNotebookDocument.
 * Use `create(WorksheetNotebookDocumentSchema)` to create a new message.
 */
export const WorksheetNotebookDocumentSchema: GenMessage<WorksheetNotebookDocument> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 6);

/**
 * @generated from message chalk.server.v1.WorksheetDocument
 */
export type WorksheetDocument = Message<"chalk.server.v1.WorksheetDocument"> & {
  /**
   * @generated from oneof chalk.server.v1.WorksheetDocument.document
   */
  document: {
    /**
     * @generated from field: chalk.server.v1.WorksheetSqlQueryDocument sql_query = 1;
     */
    value: WorksheetSqlQueryDocument;
    case: "sqlQuery";
  } | {
    /**
     * @generated from field: chalk.server.v1.WorksheetOnlineQueryDocument online_query = 2;
     */
    value: WorksheetOnlineQueryDocument;
    case: "onlineQuery";
  } | {
    /**
     * @generated from field: chalk.server.v1.WorksheetOfflineQueryDocument offline_query = 3;
     */
    value: WorksheetOfflineQueryDocument;
    case: "offlineQuery";
  } | {
    /**
     * @generated from field: chalk.server.v1.WorksheetNotebookDocument notebook = 4;
     */
    value: WorksheetNotebookDocument;
    case: "notebook";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.WorksheetDocument.
 * Use `create(WorksheetDocumentSchema)` to create a new message.
 */
export const WorksheetDocumentSchema: GenMessage<WorksheetDocument> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 7);

/**
 * @generated from message chalk.server.v1.WorksheetContentInput
 */
export type WorksheetContentInput = Message<"chalk.server.v1.WorksheetContentInput"> & {
  /**
   * @generated from oneof chalk.server.v1.WorksheetContentInput.value
   */
  value: {
    /**
     * @generated from field: chalk.server.v1.WorksheetContent raw_content = 1;
     */
    value: WorksheetContent;
    case: "rawContent";
  } | {
    /**
     * @generated from field: chalk.server.v1.WorksheetDocument document = 2;
     */
    value: WorksheetDocument;
    case: "document";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.WorksheetContentInput.
 * Use `create(WorksheetContentInputSchema)` to create a new message.
 */
export const WorksheetContentInputSchema: GenMessage<WorksheetContentInput> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 8);

/**
 * @generated from message chalk.server.v1.WorksheetNode
 */
export type WorksheetNode = Message<"chalk.server.v1.WorksheetNode"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string space_id = 2;
   */
  spaceId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetNodeKind kind = 4;
   */
  kind: WorksheetNodeKind;

  /**
   * @generated from field: optional string parent_node_id = 5;
   */
  parentNodeId?: string;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetNodeState state = 7;
   */
  state: WorksheetNodeState;

  /**
   * Total number of opens across all users for this node. Populated on the
   * single-get response via a left-join view aggregate (0 when never viewed).
   *
   * @generated from field: int64 total_view_count = 8;
   */
  totalViewCount: bigint;

  /**
   * The requesting user's most recent open of this node. Absent (null) when
   * this user has never opened it.
   *
   * @generated from field: optional google.protobuf.Timestamp viewer_last_viewed_at = 9;
   */
  viewerLastViewedAt?: Timestamp;

  /**
   * Time of the node's most recent commit (create/save/autosave/rename/move/...).
   * Populated on the list response via a per-node latest-commit join; absent on
   * other responses and when the node has no commits.
   *
   * @generated from field: optional google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.WorksheetNode.
 * Use `create(WorksheetNodeSchema)` to create a new message.
 */
export const WorksheetNodeSchema: GenMessage<WorksheetNode> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 9);

/**
 * @generated from message chalk.server.v1.WorksheetCommit
 */
export type WorksheetCommit = Message<"chalk.server.v1.WorksheetCommit"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string space_id = 2;
   */
  spaceId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommitState state = 6;
   */
  state: WorksheetCommitState;

  /**
   * @generated from field: chalk.server.v1.WorksheetOperationKind operation_kind = 7;
   */
  operationKind: WorksheetOperationKind;

  /**
   * @generated from field: string node_id = 8;
   */
  nodeId: string;

  /**
   * @generated from field: optional string parent_node_id = 9;
   */
  parentNodeId?: string;

  /**
   * @generated from field: string name = 10;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetNodeState node_state = 11;
   */
  nodeState: WorksheetNodeState;

  /**
   * @generated from field: optional string blob_id = 12;
   */
  blobId?: string;

  /**
   * @generated from field: optional chalk.server.v1.WorksheetBlobRef blob = 13;
   */
  blob?: WorksheetBlobRef;
};

/**
 * Describes the message chalk.server.v1.WorksheetCommit.
 * Use `create(WorksheetCommitSchema)` to create a new message.
 */
export const WorksheetCommitSchema: GenMessage<WorksheetCommit> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 10);

/**
 * @generated from message chalk.server.v1.WorksheetRun
 */
export type WorksheetRun = Message<"chalk.server.v1.WorksheetRun"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string space_id = 2;
   */
  spaceId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: optional int64 commit_id = 4;
   */
  commitId?: bigint;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string execution_operation_id = 7;
   */
  executionOperationId?: string;

  /**
   * @generated from field: string request_schema = 8;
   */
  requestSchema: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetRunLaunchStatus launch_status = 9;
   */
  launchStatus: WorksheetRunLaunchStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp launched_at = 10;
   */
  launchedAt?: Timestamp;

  /**
   * @generated from field: optional string launch_error = 11;
   */
  launchError?: string;
};

/**
 * Describes the message chalk.server.v1.WorksheetRun.
 * Use `create(WorksheetRunSchema)` to create a new message.
 */
export const WorksheetRunSchema: GenMessage<WorksheetRun> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 11);

/**
 * @generated from message chalk.server.v1.CreateWorksheetSpaceRequest
 */
export type CreateWorksheetSpaceRequest = Message<"chalk.server.v1.CreateWorksheetSpaceRequest"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetSpaceVisibility visibility = 1;
   */
  visibility: WorksheetSpaceVisibility;
};

/**
 * Describes the message chalk.server.v1.CreateWorksheetSpaceRequest.
 * Use `create(CreateWorksheetSpaceRequestSchema)` to create a new message.
 */
export const CreateWorksheetSpaceRequestSchema: GenMessage<CreateWorksheetSpaceRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 12);

/**
 * @generated from message chalk.server.v1.CreateWorksheetSpaceResponse
 */
export type CreateWorksheetSpaceResponse = Message<"chalk.server.v1.CreateWorksheetSpaceResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetSpace space = 1;
   */
  space?: WorksheetSpace;
};

/**
 * Describes the message chalk.server.v1.CreateWorksheetSpaceResponse.
 * Use `create(CreateWorksheetSpaceResponseSchema)` to create a new message.
 */
export const CreateWorksheetSpaceResponseSchema: GenMessage<CreateWorksheetSpaceResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 13);

/**
 * @generated from message chalk.server.v1.ListWorksheetSpacesRequest
 */
export type ListWorksheetSpacesRequest = Message<"chalk.server.v1.ListWorksheetSpacesRequest"> & {
};

/**
 * Describes the message chalk.server.v1.ListWorksheetSpacesRequest.
 * Use `create(ListWorksheetSpacesRequestSchema)` to create a new message.
 */
export const ListWorksheetSpacesRequestSchema: GenMessage<ListWorksheetSpacesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 14);

/**
 * @generated from message chalk.server.v1.ListWorksheetSpacesResponse
 */
export type ListWorksheetSpacesResponse = Message<"chalk.server.v1.ListWorksheetSpacesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorksheetSpace spaces = 1;
   */
  spaces: WorksheetSpace[];
};

/**
 * Describes the message chalk.server.v1.ListWorksheetSpacesResponse.
 * Use `create(ListWorksheetSpacesResponseSchema)` to create a new message.
 */
export const ListWorksheetSpacesResponseSchema: GenMessage<ListWorksheetSpacesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 15);

/**
 * @generated from message chalk.server.v1.GetWorksheetNodeRequest
 */
export type GetWorksheetNodeRequest = Message<"chalk.server.v1.GetWorksheetNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetNodeRequest.
 * Use `create(GetWorksheetNodeRequestSchema)` to create a new message.
 */
export const GetWorksheetNodeRequestSchema: GenMessage<GetWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 16);

/**
 * @generated from message chalk.server.v1.GetWorksheetNodeResponse
 */
export type GetWorksheetNodeResponse = Message<"chalk.server.v1.GetWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetNodeResponse.
 * Use `create(GetWorksheetNodeResponseSchema)` to create a new message.
 */
export const GetWorksheetNodeResponseSchema: GenMessage<GetWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 17);

/**
 * @generated from message chalk.server.v1.ListWorksheetNodesRequest
 */
export type ListWorksheetNodesRequest = Message<"chalk.server.v1.ListWorksheetNodesRequest"> & {
  /**
   * @generated from field: string space_id = 1;
   */
  spaceId: string;

  /**
   * @generated from field: optional string parent_node_id = 2;
   */
  parentNodeId?: string;

  /**
   * @generated from field: bool include_archived = 3;
   */
  includeArchived: boolean;
};

/**
 * Describes the message chalk.server.v1.ListWorksheetNodesRequest.
 * Use `create(ListWorksheetNodesRequestSchema)` to create a new message.
 */
export const ListWorksheetNodesRequestSchema: GenMessage<ListWorksheetNodesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 18);

/**
 * @generated from message chalk.server.v1.ListWorksheetNodesResponse
 */
export type ListWorksheetNodesResponse = Message<"chalk.server.v1.ListWorksheetNodesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorksheetNode nodes = 1;
   */
  nodes: WorksheetNode[];
};

/**
 * Describes the message chalk.server.v1.ListWorksheetNodesResponse.
 * Use `create(ListWorksheetNodesResponseSchema)` to create a new message.
 */
export const ListWorksheetNodesResponseSchema: GenMessage<ListWorksheetNodesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 19);

/**
 * @generated from message chalk.server.v1.CreateWorksheetNodeRequest
 */
export type CreateWorksheetNodeRequest = Message<"chalk.server.v1.CreateWorksheetNodeRequest"> & {
  /**
   * @generated from field: string space_id = 1;
   */
  spaceId: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetNodeKind kind = 2;
   */
  kind: WorksheetNodeKind;

  /**
   * @generated from field: optional string parent_node_id = 3;
   */
  parentNodeId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional chalk.server.v1.WorksheetContentInput content = 5;
   */
  content?: WorksheetContentInput;
};

/**
 * Describes the message chalk.server.v1.CreateWorksheetNodeRequest.
 * Use `create(CreateWorksheetNodeRequestSchema)` to create a new message.
 */
export const CreateWorksheetNodeRequestSchema: GenMessage<CreateWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 20);

/**
 * @generated from message chalk.server.v1.CreateWorksheetNodeResponse
 */
export type CreateWorksheetNodeResponse = Message<"chalk.server.v1.CreateWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 2;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.CreateWorksheetNodeResponse.
 * Use `create(CreateWorksheetNodeResponseSchema)` to create a new message.
 */
export const CreateWorksheetNodeResponseSchema: GenMessage<CreateWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 21);

/**
 * @generated from message chalk.server.v1.RenameWorksheetNodeRequest
 */
export type RenameWorksheetNodeRequest = Message<"chalk.server.v1.RenameWorksheetNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message chalk.server.v1.RenameWorksheetNodeRequest.
 * Use `create(RenameWorksheetNodeRequestSchema)` to create a new message.
 */
export const RenameWorksheetNodeRequestSchema: GenMessage<RenameWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 22);

/**
 * @generated from message chalk.server.v1.RenameWorksheetNodeResponse
 */
export type RenameWorksheetNodeResponse = Message<"chalk.server.v1.RenameWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 2;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.RenameWorksheetNodeResponse.
 * Use `create(RenameWorksheetNodeResponseSchema)` to create a new message.
 */
export const RenameWorksheetNodeResponseSchema: GenMessage<RenameWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 23);

/**
 * @generated from message chalk.server.v1.MoveWorksheetNodeRequest
 */
export type MoveWorksheetNodeRequest = Message<"chalk.server.v1.MoveWorksheetNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: optional string parent_node_id = 2;
   */
  parentNodeId?: string;

  /**
   * @generated from field: optional string space_id = 3;
   */
  spaceId?: string;
};

/**
 * Describes the message chalk.server.v1.MoveWorksheetNodeRequest.
 * Use `create(MoveWorksheetNodeRequestSchema)` to create a new message.
 */
export const MoveWorksheetNodeRequestSchema: GenMessage<MoveWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 24);

/**
 * @generated from message chalk.server.v1.MoveWorksheetNodeResponse
 */
export type MoveWorksheetNodeResponse = Message<"chalk.server.v1.MoveWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 2;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.MoveWorksheetNodeResponse.
 * Use `create(MoveWorksheetNodeResponseSchema)` to create a new message.
 */
export const MoveWorksheetNodeResponseSchema: GenMessage<MoveWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 25);

/**
 * @generated from message chalk.server.v1.ArchiveWorksheetNodeRequest
 */
export type ArchiveWorksheetNodeRequest = Message<"chalk.server.v1.ArchiveWorksheetNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message chalk.server.v1.ArchiveWorksheetNodeRequest.
 * Use `create(ArchiveWorksheetNodeRequestSchema)` to create a new message.
 */
export const ArchiveWorksheetNodeRequestSchema: GenMessage<ArchiveWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 26);

/**
 * @generated from message chalk.server.v1.ArchiveWorksheetNodeResponse
 */
export type ArchiveWorksheetNodeResponse = Message<"chalk.server.v1.ArchiveWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 2;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.ArchiveWorksheetNodeResponse.
 * Use `create(ArchiveWorksheetNodeResponseSchema)` to create a new message.
 */
export const ArchiveWorksheetNodeResponseSchema: GenMessage<ArchiveWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 27);

/**
 * @generated from message chalk.server.v1.RestoreWorksheetNodeRequest
 */
export type RestoreWorksheetNodeRequest = Message<"chalk.server.v1.RestoreWorksheetNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: optional string parent_node_id = 2;
   */
  parentNodeId?: string;
};

/**
 * Describes the message chalk.server.v1.RestoreWorksheetNodeRequest.
 * Use `create(RestoreWorksheetNodeRequestSchema)` to create a new message.
 */
export const RestoreWorksheetNodeRequestSchema: GenMessage<RestoreWorksheetNodeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 28);

/**
 * @generated from message chalk.server.v1.RestoreWorksheetNodeResponse
 */
export type RestoreWorksheetNodeResponse = Message<"chalk.server.v1.RestoreWorksheetNodeResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetNode node = 1;
   */
  node?: WorksheetNode;

  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 2;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.RestoreWorksheetNodeResponse.
 * Use `create(RestoreWorksheetNodeResponseSchema)` to create a new message.
 */
export const RestoreWorksheetNodeResponseSchema: GenMessage<RestoreWorksheetNodeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 29);

/**
 * @generated from message chalk.server.v1.AutosaveWorksheetRequest
 */
export type AutosaveWorksheetRequest = Message<"chalk.server.v1.AutosaveWorksheetRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: chalk.server.v1.WorksheetContentInput content = 2;
   */
  content?: WorksheetContentInput;
};

/**
 * Describes the message chalk.server.v1.AutosaveWorksheetRequest.
 * Use `create(AutosaveWorksheetRequestSchema)` to create a new message.
 */
export const AutosaveWorksheetRequestSchema: GenMessage<AutosaveWorksheetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 30);

/**
 * @generated from message chalk.server.v1.AutosaveWorksheetResponse
 */
export type AutosaveWorksheetResponse = Message<"chalk.server.v1.AutosaveWorksheetResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 1;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.AutosaveWorksheetResponse.
 * Use `create(AutosaveWorksheetResponseSchema)` to create a new message.
 */
export const AutosaveWorksheetResponseSchema: GenMessage<AutosaveWorksheetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 31);

/**
 * @generated from message chalk.server.v1.SaveWorksheetRequest
 */
export type SaveWorksheetRequest = Message<"chalk.server.v1.SaveWorksheetRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: optional chalk.server.v1.WorksheetContentInput content = 2;
   */
  content?: WorksheetContentInput;
};

/**
 * Describes the message chalk.server.v1.SaveWorksheetRequest.
 * Use `create(SaveWorksheetRequestSchema)` to create a new message.
 */
export const SaveWorksheetRequestSchema: GenMessage<SaveWorksheetRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 32);

/**
 * @generated from message chalk.server.v1.SaveWorksheetResponse
 */
export type SaveWorksheetResponse = Message<"chalk.server.v1.SaveWorksheetResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 1;
   */
  commit?: WorksheetCommit;
};

/**
 * Describes the message chalk.server.v1.SaveWorksheetResponse.
 * Use `create(SaveWorksheetResponseSchema)` to create a new message.
 */
export const SaveWorksheetResponseSchema: GenMessage<SaveWorksheetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 33);

/**
 * @generated from message chalk.server.v1.GetWorksheetCommitRequest
 */
export type GetWorksheetCommitRequest = Message<"chalk.server.v1.GetWorksheetCommitRequest"> & {
  /**
   * @generated from field: int64 commit_id = 1;
   */
  commitId: bigint;

  /**
   * @generated from field: bool include_content = 2;
   */
  includeContent: boolean;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetCommitRequest.
 * Use `create(GetWorksheetCommitRequestSchema)` to create a new message.
 */
export const GetWorksheetCommitRequestSchema: GenMessage<GetWorksheetCommitRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 34);

/**
 * @generated from message chalk.server.v1.GetWorksheetCommitResponse
 */
export type GetWorksheetCommitResponse = Message<"chalk.server.v1.GetWorksheetCommitResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetCommit commit = 1;
   */
  commit?: WorksheetCommit;

  /**
   * @generated from field: optional chalk.server.v1.WorksheetContent content = 2;
   */
  content?: WorksheetContent;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetCommitResponse.
 * Use `create(GetWorksheetCommitResponseSchema)` to create a new message.
 */
export const GetWorksheetCommitResponseSchema: GenMessage<GetWorksheetCommitResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 35);

/**
 * @generated from message chalk.server.v1.ListWorksheetCommitsRequest
 */
export type ListWorksheetCommitsRequest = Message<"chalk.server.v1.ListWorksheetCommitsRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: bool include_drafts = 2;
   */
  includeDrafts: boolean;

  /**
   * @generated from field: optional int64 before_commit_id = 3;
   */
  beforeCommitId?: bigint;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListWorksheetCommitsRequest.
 * Use `create(ListWorksheetCommitsRequestSchema)` to create a new message.
 */
export const ListWorksheetCommitsRequestSchema: GenMessage<ListWorksheetCommitsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 36);

/**
 * @generated from message chalk.server.v1.ListWorksheetCommitsResponse
 */
export type ListWorksheetCommitsResponse = Message<"chalk.server.v1.ListWorksheetCommitsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorksheetCommit commits = 1;
   */
  commits: WorksheetCommit[];
};

/**
 * Describes the message chalk.server.v1.ListWorksheetCommitsResponse.
 * Use `create(ListWorksheetCommitsResponseSchema)` to create a new message.
 */
export const ListWorksheetCommitsResponseSchema: GenMessage<ListWorksheetCommitsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 37);

/**
 * @generated from message chalk.server.v1.RunOnlineWorksheetCommitRequest
 */
export type RunOnlineWorksheetCommitRequest = Message<"chalk.server.v1.RunOnlineWorksheetCommitRequest"> & {
  /**
   * @generated from field: int64 commit_id = 1;
   */
  commitId: bigint;

  /**
   * @generated from field: chalk.common.v1.OnlineQueryRequest online_query_request = 2;
   */
  onlineQueryRequest?: OnlineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.RunOnlineWorksheetCommitRequest.
 * Use `create(RunOnlineWorksheetCommitRequestSchema)` to create a new message.
 */
export const RunOnlineWorksheetCommitRequestSchema: GenMessage<RunOnlineWorksheetCommitRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 38);

/**
 * @generated from message chalk.server.v1.RunOnlineWorksheetCommitResponse
 */
export type RunOnlineWorksheetCommitResponse = Message<"chalk.server.v1.RunOnlineWorksheetCommitResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetRun run = 1;
   */
  run?: WorksheetRun;

  /**
   * @generated from field: chalk.common.v1.OnlineQueryResponse online_query_response = 2;
   */
  onlineQueryResponse?: OnlineQueryResponse;
};

/**
 * Describes the message chalk.server.v1.RunOnlineWorksheetCommitResponse.
 * Use `create(RunOnlineWorksheetCommitResponseSchema)` to create a new message.
 */
export const RunOnlineWorksheetCommitResponseSchema: GenMessage<RunOnlineWorksheetCommitResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 39);

/**
 * @generated from message chalk.server.v1.RunOfflineWorksheetCommitRequest
 */
export type RunOfflineWorksheetCommitRequest = Message<"chalk.server.v1.RunOfflineWorksheetCommitRequest"> & {
  /**
   * @generated from field: int64 commit_id = 1;
   */
  commitId: bigint;

  /**
   * @generated from field: chalk.common.v1.OfflineQueryRequest offline_query_request = 2;
   */
  offlineQueryRequest?: OfflineQueryRequest;
};

/**
 * Describes the message chalk.server.v1.RunOfflineWorksheetCommitRequest.
 * Use `create(RunOfflineWorksheetCommitRequestSchema)` to create a new message.
 */
export const RunOfflineWorksheetCommitRequestSchema: GenMessage<RunOfflineWorksheetCommitRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 40);

/**
 * @generated from message chalk.server.v1.RunOfflineWorksheetCommitResponse
 */
export type RunOfflineWorksheetCommitResponse = Message<"chalk.server.v1.RunOfflineWorksheetCommitResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetRun run = 1;
   */
  run?: WorksheetRun;

  /**
   * @generated from field: chalk.common.v1.DatasetResponse dataset_response = 2;
   */
  datasetResponse?: DatasetResponse;
};

/**
 * Describes the message chalk.server.v1.RunOfflineWorksheetCommitResponse.
 * Use `create(RunOfflineWorksheetCommitResponseSchema)` to create a new message.
 */
export const RunOfflineWorksheetCommitResponseSchema: GenMessage<RunOfflineWorksheetCommitResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 41);

/**
 * @generated from message chalk.server.v1.RunSqlWorksheetCommitRequest
 */
export type RunSqlWorksheetCommitRequest = Message<"chalk.server.v1.RunSqlWorksheetCommitRequest"> & {
  /**
   * @generated from field: int64 commit_id = 1;
   */
  commitId: bigint;

  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryRequest sql_query_request = 2;
   */
  sqlQueryRequest?: ExecuteSqlQueryRequest;
};

/**
 * Describes the message chalk.server.v1.RunSqlWorksheetCommitRequest.
 * Use `create(RunSqlWorksheetCommitRequestSchema)` to create a new message.
 */
export const RunSqlWorksheetCommitRequestSchema: GenMessage<RunSqlWorksheetCommitRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 42);

/**
 * @generated from message chalk.server.v1.RunSqlWorksheetCommitResponse
 */
export type RunSqlWorksheetCommitResponse = Message<"chalk.server.v1.RunSqlWorksheetCommitResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetRun run = 1;
   */
  run?: WorksheetRun;

  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryResponse sql_query_response = 2;
   */
  sqlQueryResponse?: ExecuteSqlQueryResponse;
};

/**
 * Describes the message chalk.server.v1.RunSqlWorksheetCommitResponse.
 * Use `create(RunSqlWorksheetCommitResponseSchema)` to create a new message.
 */
export const RunSqlWorksheetCommitResponseSchema: GenMessage<RunSqlWorksheetCommitResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 43);

/**
 * @generated from message chalk.server.v1.CancelWorksheetRunRequest
 */
export type CancelWorksheetRunRequest = Message<"chalk.server.v1.CancelWorksheetRunRequest"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;
};

/**
 * Describes the message chalk.server.v1.CancelWorksheetRunRequest.
 * Use `create(CancelWorksheetRunRequestSchema)` to create a new message.
 */
export const CancelWorksheetRunRequestSchema: GenMessage<CancelWorksheetRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 44);

/**
 * @generated from message chalk.server.v1.CancelWorksheetRunResponse
 */
export type CancelWorksheetRunResponse = Message<"chalk.server.v1.CancelWorksheetRunResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetRun run = 1;
   */
  run?: WorksheetRun;
};

/**
 * Describes the message chalk.server.v1.CancelWorksheetRunResponse.
 * Use `create(CancelWorksheetRunResponseSchema)` to create a new message.
 */
export const CancelWorksheetRunResponseSchema: GenMessage<CancelWorksheetRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 45);

/**
 * @generated from message chalk.server.v1.GetWorksheetRunRequest
 */
export type GetWorksheetRunRequest = Message<"chalk.server.v1.GetWorksheetRunRequest"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetRunRequest.
 * Use `create(GetWorksheetRunRequestSchema)` to create a new message.
 */
export const GetWorksheetRunRequestSchema: GenMessage<GetWorksheetRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 46);

/**
 * @generated from message chalk.server.v1.GetWorksheetRunResponse
 */
export type GetWorksheetRunResponse = Message<"chalk.server.v1.GetWorksheetRunResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorksheetRun run = 1;
   */
  run?: WorksheetRun;
};

/**
 * Describes the message chalk.server.v1.GetWorksheetRunResponse.
 * Use `create(GetWorksheetRunResponseSchema)` to create a new message.
 */
export const GetWorksheetRunResponseSchema: GenMessage<GetWorksheetRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 47);

/**
 * @generated from message chalk.server.v1.ListWorksheetRunsRequest
 */
export type ListWorksheetRunsRequest = Message<"chalk.server.v1.ListWorksheetRunsRequest"> & {
  /**
   * @generated from field: optional string node_id = 1;
   */
  nodeId?: string;

  /**
   * @generated from field: optional int64 commit_id = 2;
   */
  commitId?: bigint;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListWorksheetRunsRequest.
 * Use `create(ListWorksheetRunsRequestSchema)` to create a new message.
 */
export const ListWorksheetRunsRequestSchema: GenMessage<ListWorksheetRunsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 48);

/**
 * @generated from message chalk.server.v1.ListWorksheetRunsResponse
 */
export type ListWorksheetRunsResponse = Message<"chalk.server.v1.ListWorksheetRunsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorksheetRun runs = 1;
   */
  runs: WorksheetRun[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListWorksheetRunsResponse.
 * Use `create(ListWorksheetRunsResponseSchema)` to create a new message.
 */
export const ListWorksheetRunsResponseSchema: GenMessage<ListWorksheetRunsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_worksheets, 49);

/**
 * @generated from enum chalk.server.v1.WorksheetSpaceVisibility
 */
export enum WorksheetSpaceVisibility {
  /**
   * @generated from enum value: WORKSHEET_SPACE_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_SPACE_VISIBILITY_SHARED = 1;
   */
  SHARED = 1,

  /**
   * @generated from enum value: WORKSHEET_SPACE_VISIBILITY_PRIVATE = 2;
   */
  PRIVATE = 2,
}

/**
 * Describes the enum chalk.server.v1.WorksheetSpaceVisibility.
 */
export const WorksheetSpaceVisibilitySchema: GenEnum<WorksheetSpaceVisibility> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 0);

/**
 * @generated from enum chalk.server.v1.WorksheetNodeKind
 */
export enum WorksheetNodeKind {
  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_FOLDER = 1;
   */
  FOLDER = 1,

  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_SQL_QUERY = 2;
   */
  SQL_QUERY = 2,

  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_ONLINE_QUERY = 3;
   */
  ONLINE_QUERY = 3,

  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_OFFLINE_QUERY = 4;
   */
  OFFLINE_QUERY = 4,

  /**
   * @generated from enum value: WORKSHEET_NODE_KIND_NOTEBOOK = 5;
   */
  NOTEBOOK = 5,
}

/**
 * Describes the enum chalk.server.v1.WorksheetNodeKind.
 */
export const WorksheetNodeKindSchema: GenEnum<WorksheetNodeKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 1);

/**
 * @generated from enum chalk.server.v1.WorksheetNodeState
 */
export enum WorksheetNodeState {
  /**
   * @generated from enum value: WORKSHEET_NODE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_NODE_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: WORKSHEET_NODE_STATE_ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum chalk.server.v1.WorksheetNodeState.
 */
export const WorksheetNodeStateSchema: GenEnum<WorksheetNodeState> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 2);

/**
 * @generated from enum chalk.server.v1.WorksheetCommitState
 */
export enum WorksheetCommitState {
  /**
   * @generated from enum value: WORKSHEET_COMMIT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_COMMIT_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: WORKSHEET_COMMIT_STATE_SAVED = 2;
   */
  SAVED = 2,
}

/**
 * Describes the enum chalk.server.v1.WorksheetCommitState.
 */
export const WorksheetCommitStateSchema: GenEnum<WorksheetCommitState> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 3);

/**
 * @generated from enum chalk.server.v1.WorksheetOperationKind
 */
export enum WorksheetOperationKind {
  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_AUTOSAVE = 1;
   */
  AUTOSAVE = 1,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_CREATE = 2;
   */
  CREATE = 2,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_SAVE = 3;
   */
  SAVE = 3,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_RENAME = 4;
   */
  RENAME = 4,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_MOVE = 5;
   */
  MOVE = 5,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_ARCHIVE = 6;
   */
  ARCHIVE = 6,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_RESTORE = 7;
   */
  RESTORE = 7,

  /**
   * @generated from enum value: WORKSHEET_OPERATION_KIND_DUPLICATE = 8;
   */
  DUPLICATE = 8,
}

/**
 * Describes the enum chalk.server.v1.WorksheetOperationKind.
 */
export const WorksheetOperationKindSchema: GenEnum<WorksheetOperationKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 4);

/**
 * @generated from enum chalk.server.v1.WorksheetRunLaunchStatus
 */
export enum WorksheetRunLaunchStatus {
  /**
   * @generated from enum value: WORKSHEET_RUN_LAUNCH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKSHEET_RUN_LAUNCH_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKSHEET_RUN_LAUNCH_STATUS_LAUNCHED = 2;
   */
  LAUNCHED = 2,

  /**
   * @generated from enum value: WORKSHEET_RUN_LAUNCH_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum chalk.server.v1.WorksheetRunLaunchStatus.
 */
export const WorksheetRunLaunchStatusSchema: GenEnum<WorksheetRunLaunchStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_worksheets, 5);

/**
 * @generated from service chalk.server.v1.WorksheetsService
 */
export const WorksheetsService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.CreateWorksheetSpace
   */
  createWorksheetSpace: {
    methodKind: "unary";
    input: typeof CreateWorksheetSpaceRequestSchema;
    output: typeof CreateWorksheetSpaceResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetSpaces
   */
  listWorksheetSpaces: {
    methodKind: "unary";
    input: typeof ListWorksheetSpacesRequestSchema;
    output: typeof ListWorksheetSpacesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetNode
   */
  getWorksheetNode: {
    methodKind: "unary";
    input: typeof GetWorksheetNodeRequestSchema;
    output: typeof GetWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetNodes
   */
  listWorksheetNodes: {
    methodKind: "unary";
    input: typeof ListWorksheetNodesRequestSchema;
    output: typeof ListWorksheetNodesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.CreateWorksheetNode
   */
  createWorksheetNode: {
    methodKind: "unary";
    input: typeof CreateWorksheetNodeRequestSchema;
    output: typeof CreateWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.RenameWorksheetNode
   */
  renameWorksheetNode: {
    methodKind: "unary";
    input: typeof RenameWorksheetNodeRequestSchema;
    output: typeof RenameWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.MoveWorksheetNode
   */
  moveWorksheetNode: {
    methodKind: "unary";
    input: typeof MoveWorksheetNodeRequestSchema;
    output: typeof MoveWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.ArchiveWorksheetNode
   */
  archiveWorksheetNode: {
    methodKind: "unary";
    input: typeof ArchiveWorksheetNodeRequestSchema;
    output: typeof ArchiveWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.RestoreWorksheetNode
   */
  restoreWorksheetNode: {
    methodKind: "unary";
    input: typeof RestoreWorksheetNodeRequestSchema;
    output: typeof RestoreWorksheetNodeResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.AutosaveWorksheet
   */
  autosaveWorksheet: {
    methodKind: "unary";
    input: typeof AutosaveWorksheetRequestSchema;
    output: typeof AutosaveWorksheetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.SaveWorksheet
   */
  saveWorksheet: {
    methodKind: "unary";
    input: typeof SaveWorksheetRequestSchema;
    output: typeof SaveWorksheetResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetCommit
   */
  getWorksheetCommit: {
    methodKind: "unary";
    input: typeof GetWorksheetCommitRequestSchema;
    output: typeof GetWorksheetCommitResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetCommits
   */
  listWorksheetCommits: {
    methodKind: "unary";
    input: typeof ListWorksheetCommitsRequestSchema;
    output: typeof ListWorksheetCommitsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.RunOnlineWorksheetCommit
   */
  runOnlineWorksheetCommit: {
    methodKind: "unary";
    input: typeof RunOnlineWorksheetCommitRequestSchema;
    output: typeof RunOnlineWorksheetCommitResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.RunOfflineWorksheetCommit
   */
  runOfflineWorksheetCommit: {
    methodKind: "unary";
    input: typeof RunOfflineWorksheetCommitRequestSchema;
    output: typeof RunOfflineWorksheetCommitResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.RunSqlWorksheetCommit
   */
  runSqlWorksheetCommit: {
    methodKind: "unary";
    input: typeof RunSqlWorksheetCommitRequestSchema;
    output: typeof RunSqlWorksheetCommitResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.CancelWorksheetRun
   */
  cancelWorksheetRun: {
    methodKind: "unary";
    input: typeof CancelWorksheetRunRequestSchema;
    output: typeof CancelWorksheetRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.GetWorksheetRun
   */
  getWorksheetRun: {
    methodKind: "unary";
    input: typeof GetWorksheetRunRequestSchema;
    output: typeof GetWorksheetRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.WorksheetsService.ListWorksheetRuns
   */
  listWorksheetRuns: {
    methodKind: "unary";
    input: typeof ListWorksheetRunsRequestSchema;
    output: typeof ListWorksheetRunsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_worksheets, 0);

